/**
 * Taskbar/dock unread badge — the Badging API (`navigator.setAppBadge` /
 * `clearAppBadge`). This is the small counter that sits on the app's icon
 * itself (Windows taskbar, macOS dock) once RoamNote is installed as its
 * own app; it has nothing to do with the push-notification popup (see
 * push.js) — the two are independent and meant to run together, one
 * transient, one persistent until read.
 *
 * Only Chrome/Edge support it today, and only really shows up once
 * installed (an ordinary browser tab has no icon of its own to badge), so
 * every call here is feature-detected and best-effort — never worth
 * breaking anything else over.
 */
export function updateAppBadge(count) {
  if (typeof navigator === "undefined" || !("setAppBadge" in navigator)) return;
  try {
    const result = count > 0 ? navigator.setAppBadge(count) : navigator.clearAppBadge();
    // Both return a Promise in every implementation that has them, but
    // guard anyway rather than assume.
    if (result && typeof result.catch === "function") {
      result.catch(() => {
        // Best-effort — a failure here (e.g. not installed, browser quirk)
        // just means no badge this time, not something worth surfacing.
      });
    }
  } catch {
    // Same — swallow, never let this take anything else down with it.
  }
}
